import { useNavigate } from "react-router-dom";
import logo from "../../../../assets/logo.png";
import { useAppDispatch } from "../../../../store/store";
import Burger_Menu from "../../../../assets/icons/burger_menu.svg";
import { setProfileSideMenuOpen } from "../../../../store/features/profileSlice";
import { Box } from "@mui/material";

export const ProfileAffiliatesHeaderMobile = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <div className="profile-affiliates-header-mobile-wrapper">
      <img
        src={logo}
        style={{ width: "97px", cursor: "pointer" }}
        onClick={() => navigate("/home")}
      />

      <Box display={"flex"} alignItems={"center"}>
        <img
          src={Burger_Menu}
          onClick={() => dispatch(setProfileSideMenuOpen())}
          alt="burger_menu"
          style={{ cursor: "pointer" }}
        />
      </Box>
    </div>
  );
};
